export default __webpack_public_path__ + "static/media/pin-on-white.cbd8b8b5.svg";